import { InviteRoutes } from '../account/invite/invite.routes';
import { Routes } from '@angular/router';

export const vitalsChcekerRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'account',
  },
  {
    path: 'account',
    children: [
      {
        path: '',
        data: {
          type: 'vitals-checker',
        },
        loadComponent: () => import('../get-care/select-account/select-account.page').then((m) => m.SelectAccountPage),
      },
      {
        path: 'invite',
        loadComponent: () => import('../account/invite/invite.page').then((m) => m.InvitePage),
        children: InviteRoutes,
      },
    ],
  },
  {
    path: 'measure',
    loadComponent: () => import('./measurement/vitals-measurement.page').then((m) => m.VitalsMeasurementPage),
  },
  {
    path: 'history',
    loadComponent: () => import('./history/vitals-history.page').then((m) => m.VitalsHistoryPage),
  },
];
